import { Injectable, OnDestroy } from '@angular/core';
import { Firestore, doc, docData } from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService implements OnDestroy {

  destroy$ = new Subject<void>();
  maintenanceInfo$: Observable<any>;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private firestore: Firestore) { 
      this.maintenanceInfo$ = this.getMaintenanceState();
    }

  getMaintenanceState() {
    const stateRef = doc(this.firestore, 'portail-maintenance/portail-maintenance');
    return docData(stateRef);
  }

  enableRedirection(route: string){
    this.maintenanceInfo$.pipe(
      takeUntil(this.destroy$),
      filter(state => !!state?.[route]),
    ).subscribe(_ => {
      this.dialog.closeAll();
      this.router.navigate(['/maintenance']);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
